import { render, staticRenderFns } from "./SendSecondNightWatchingNotice.vue?vue&type=template&id=e045a94a"
import script from "./SendSecondNightWatchingNotice.vue?vue&type=script&lang=js"
export * from "./SendSecondNightWatchingNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports